import React from "react";

import { useAppSelector } from "../../hooks";
import { getCurrentUser } from "../../store/userStore";
import SmallQuantityTicketView from "./small-quantity-ticket-view";
import SmallQuantityDriverForm from "./small-quantity-driver-form";

/**
 * /small-quantity/:id - the small-quantity counterpart to /ticket/:id.
 *
 * Anonymous drivers arriving from a ticket QR code get the dispatch form;
 * signed-in staff get the full edit view. Branching here rather than inside the
 * edit view keeps that view's staff-only data loading from firing for drivers.
 */
const SmallQuantityTicketRoute = () => {
  const user = useAppSelector(getCurrentUser);

  return user ? <SmallQuantityTicketView /> : <SmallQuantityDriverForm />;
};

export default SmallQuantityTicketRoute;
